import Folder from '@itau-loans-www/assets/images/folder.png'
import { SafeTag, Button } from '@itau-loans-www/components'

import Layout from '../../layouts/Summary'
import { usePendingOfferError } from './hooks'
import './pending-offer-error.scss'

const PendingOfferError = () => {
  const { handleClick, isLoading } = usePendingOfferError()

  return (
    <Layout>
      <div className="pending-offer-error">
        <SafeTag />
        <div className="pending-offer-error__container">
          <img
            src={Folder}
            alt="pasta de arquivo vazia"
            className="pending-offer-error__img"
          />

          <h1 className="pending-offer-error__title">
            Desculpe, não foi possível prosseguir com a sua proposta
          </h1>
          <p className="pending-offer-error__description">
            Para iniciar uma nova proposta, clique no botão abaixo.
          </p>
          <Button fluid isLoading={isLoading} onClick={handleClick}>
            Fazer nova simulação
          </Button>
        </div>
      </div>
    </Layout>
  )
}

export default PendingOfferError
